import { createApi, createDomain } from 'effector';
import produce, { type Draft } from 'immer';
import type { TagLine } from '@types';

const domain = createDomain('editingTagLine');

export interface ETStore {
  tagLine: TagLine;
  //   sceneId: GeneralID;
  isNew?: boolean;
}

export const $editingTagLine = domain.store<ETStore | null>(null);
export const $editingTagLineApi = createApi($editingTagLine, {
  set: (state, payloed: ETStore | null) => payloed,
  clear: () => null,
  update: (state, updater: (draft: Draft<TagLine>) => TagLine | void) => {
    if (!state) return state;
    const newData = produce(state.tagLine, updater);
    return { ...state, tagLine: newData };
  },
});
